import { Directory } from "../../../../../domain/drawing";

export class FormatReferenceTreeEditDialogModel<T> {
  constructor() {
    this.clear();
  }
  editingDirectories: Directory<string, T>[];
  selectedDirectory: Directory<string, T>;
  selectedFormat: T;
  editFolderText: string;
  editFormatText: string;
  addFolderText: string;
  addDirectory: Directory<string, T>;
  addFormats: T[];
  deleteFolderFlag: boolean;
  deleteFormatFlag: boolean;
  updateCompletedDirectoriesFlag: boolean;
  completedDirectories: Directory<string, T>[];

  clear(): void {
    this.editingDirectories = null;
    this.selectedDirectory = null;
    this.selectedFormat = null;
    this.editFolderText = "";
    this.editFormatText = "";
    this.addFolderText = "";
    this.addDirectory = null;
    this.addFormats = null;
    this.deleteFolderFlag = false;
    this.deleteFormatFlag = false;
    this.updateCompletedDirectoriesFlag = false;
    this.completedDirectories = null;
  }
}
